export const CellDefaultWidth = 120

export const SelectionMode = {
  Single: 'single',
  Multiple: 'multiple',
}
